import { createContext } from 'react';
var LocaleContext = /*#__PURE__*/createContext(undefined);
export default LocaleContext;